import useMediaQuery from '@mui/material/useMediaQuery'
import { observer } from 'mobx-react-lite'
import { ReactElement, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { StoreInstances } from '../../../store/StoreInstancesContainer'
import { CatalogTab } from '../../../store/uiState/UiStateStore'
import { breakpoints } from '../../../theme/breakpoints'
import { SimpleModal } from '../../../ui-components/modals/SimpleModal'

interface VehicleRequiredModalProps {
  isMobile?: boolean
}

const VehicleRequiredModal = observer(
  (props: VehicleRequiredModalProps): ReactElement | null => {
    const { isMobile } = props
    const [showVehicleRequired, setShowVehicleRequired] = useState(true)
    const navigate = useNavigate()
    const { uiStore } = StoreInstances
    // Desktop + mobile selectors both mount; Bootstrap Modal portals to body so
    // CSS display:none on the unused selector does not hide its modal.
    const isMobileViewport = useMediaQuery(
      `(max-width: ${breakpoints.tabletXLarge}px)`
    )
    const matchesViewport = Boolean(isMobile) === isMobileViewport

    if (!matchesViewport) {
      return null
    }

    const handleVehicleRequired = (): void => {
      setShowVehicleRequired(false)
      navigate('/home')
    }

    const handleGoToAstCatalog = (): void => {
      uiStore.selectedCatalogTab = CatalogTab.AST_CATALOG
    }

    return (
      <SimpleModal
        show={
          !StoreInstances.searchStore.currentVehicle?.engine &&
          showVehicleRequired
        }
        title="vehicleRequired"
        primaryActionText={
          isMobile ? 'goToASTCatalog' : 'goToAccessoriesSuppliesAndTools'
        }
        onPrimaryAction={handleGoToAstCatalog}
        secondaryActionText="selectAVehicle"
        onSecondaryAction={handleVehicleRequired}
        buttonsDirection={isMobile ? 'column' : 'row'}
        primaryButtonToTheLeft={isMobile}
      >
        vehicleRequiredForSearch
      </SimpleModal>
    )
  }
)

VehicleRequiredModal.displayName = 'VehicleRequiredModal'

export default VehicleRequiredModal
